/**
 * Thread-kind classifier. `clericalThreads.kind` is only set to "chat" (web
 * Chat UI); other origins are inferred from `clericalThreadId` prefix:
 * email: (Outlook add-in), teams: (Teams bot), drive- (agent-cli). Bridges
 * both so the staff "All threads" sidebar can show a stable kind badge.
 */

export type DerivedThreadKind = "chat" | "email" | "teams" | "cli" | "other";

const PREFIX_RULES: ReadonlyArray<{
	prefix: string;
	kind: DerivedThreadKind;
}> = [
	{ prefix: "chat:", kind: "chat" },
	{ prefix: "email:", kind: "email" },
	{ prefix: "teams:", kind: "teams" },
	{ prefix: "drive-", kind: "cli" },
];

export function deriveThreadKind(
	clericalThreadId: string,
	persistedKind?: string,
): DerivedThreadKind {
	if (persistedKind === "chat") return "chat";
	for (const rule of PREFIX_RULES) {
		if (clericalThreadId.startsWith(rule.prefix)) return rule.kind;
	}
	return "other";
}
